export function normalizeOtp(value) {
  return String(value ?? '')
    .replace(/[۰-۹]/g, digit => String(digit.charCodeAt(0) - 0x06f0))
    .replace(/[٠-٩]/g, digit => String(digit.charCodeAt(0) - 0x0660))
    .replace(/[^0-9]/g, '')
    .slice(0, 5);
}

export function otpDigits(value) {
  const normalized = normalizeOtp(value);
  return Array.from({ length: 5 }, (_, index) => normalized[index] || '');
}
